export default __webpack_public_path__ + "static/media/ilustracao-moedas.fb61dfd3.svg";